<div class="row g-0 position-relative align-items-center">
  <div class="col-md-6 p-4 pt-0">
    <div>
      <label for="camera" class="font-weight-light mt-3">{{ 'ASSESSMENTAPP.CAMERA' | translate }}</label>
      <ng-select
				[class]="ngSelectLang"
				[items]="videoDevices"
        [bindLabel]="'label'"
        [bindValue]="'deviceId'"
        [clearable]="false"
        [searchable]="false"
        [(ngModel)]="selectedCamera"
        placeholder=""
        class="w-100"
        (change)="startVideoStream()" 
      >
      </ng-select>
    </div>
    <div class="mt-3">
      <label for="speakers" class="font-weight-light">{{ 'ASSESSMENTAPP.SPEAKERS' | translate }}</label>
      <div class="input-group flex-nowrap">
        <ng-select
					[class]="ngSelectLang"
          [items]="audioOutputDevices"
          [bindLabel]="'label'"
          [bindValue]="'deviceId'"
          [clearable]="false"
          [searchable]="false"
          [(ngModel)]="selectedSpeaker"
          placeholder=""
          class="w-100"
        >
        </ng-select>
        <label class="input-group-text p-0 border-0" [ngClass]="lang === 'he' ? 'me-1' : 'ms-1'" for="sound">
          <button
            type="button"
            style="background: #5b7ffc;"
            class="btn btn-info waves-effect waves-light"
            (click)="playsound()"
            title="Test Speaker"
          >
            <i class="ri-volume-up-line align-bottom"></i>
          </button>
        </label>
      </div>
    </div>
    <div class="mt-3">
      <label for="mic" class="font-weight-light">{{ 'ASSESSMENTAPP.MIC' | translate }}</label>
      <div class="input-group flex-nowrap">
        <ng-select
					[class]="ngSelectLang"
					[items]="audioInputDevices"
          [bindLabel]="'label'"
          [bindValue]="'deviceId'"
          [clearable]="false"
          [searchable]="false"
          [(ngModel)]="selectedMicrophone"
          placeholder=""
          class="w-100"
          (change)="startMicrophoneStream()" 
        >
        </ng-select>
        <label class="input-group-text p-0 border-0" [ngClass]="lang === 'he' ? 'me-1' : 'ms-1'" for="mute">
          <button
            type="button"
            style="background: #5b7ffc;"
            class="btn btn-info waves-effect waves-light"
            (click)="muteStatusChange()"
            title="Test Speaker"
          >
            <i class="align-bottom" [ngClass]="muteMic ? 'ri-mic-off-line' : 'ri-mic-line'"></i>
          </button>
        </label>
      </div>
    </div>
    <div class="pids-wrapper w-100 mt-3 d-flex">
      <div class="pid rounded m-2"></div>
      <div class="pid rounded m-2"></div>
      <div class="pid rounded m-2"></div>
      <div class="pid rounded m-2"></div>
      <div class="pid rounded m-2"></div>
      <div class="pid rounded m-2"></div>
      <div class="pid rounded m-2"></div>
      <div class="pid rounded m-2"></div>
      <div class="pid rounded m-2"></div>
      <div class="pid rounded m-2"></div>
    </div>
  </div>
  <div class="col-md-6 p-4">
		<div class="ratio ratio-16x9">
			<div #videoWrapper class="column d-flex justify-content-center videoWrapper rounded">
				<video class="rounded w-100 h-100" #videoPlayer autoplay [muted]="testSpeakers || muteMic"></video>
      </div>
    </div>
		<p *ngIf="!streamService.detect_face" class="text-center pt-1 mb-0 text-danger">{{ 'ASSESSMENTAPP.DETECT_FACE' | translate }}</p>
		<p *ngIf="!streamService.light" class="text-center pt-1 mb-0 text-danger">{{ 'ASSESSMENTAPP.LIGHT_CONDITION' | translate }}</p>
		<p *ngIf="streamService.detect_face && streamService.light" class="text-center pt-1 mb-0 text-success">{{ 'ASSESSMENTAPP.CONDITIONS_GOOD' | translate }}</p>
    <audio #audioPlayer></audio>
  </div>
</div>
